<div>
    <div>
        <span *ngFor="let message of messages.values()" class="message" [ngClass]="{'reply':message.isReply}"></span>
    </div>
    <div>
        <textarea [(ngModel)]="messageContent"></textarea>
        <button (click)="onSendMessage()"></button>
    </div>
</div>